export default {
    getIsInitialLoading: state => {
        let returnVal = true;
        if (!state.layout.mainNavIsLoading && !state.layout.footerNavIsLoading) {
            returnVal = false;
        }
        return returnVal;
    },

    getMainNav: state => {
        return state.layout.mainNav;
    },
    getMainNavIsLoading: state => {
        return state.layout.mainNavIsLoading;
    },
    getFooterNav: state => {
        return state.layout.footerNav;
    },
    getFooterNavIsLoading: state => {
        return state.layout.footerNavIsLoading;
    },

    getSiteHeaderMode: state => {
        return state.layout.siteHeaderMode;
    },
    getSiteFooterVisability: state => {
        return state.layout.siteFooterVisability;
    },

};